<div class="cart-manager-section">
  
  <!-- Cart Summary (when items are selected) -->
  <div class="cart-summary" *ngIf="cartItems.length > 0">
    <h5 class="summary-title">Cart Summary</h5>
    <div class="summary-content">
      <div *ngFor="let summary of getCartSummary()" class="cart-item-summary">
        <span class="item-type">{{ summary.type }} Wheels:</span>
        <span class="item-quantity">{{ summary.quantity }} pcs</span>
      </div>
      <div class="total-quantity">
        <strong>Total Wheels: {{ getTotalQuantity() }}</strong>
      </div>
    </div>
  </div>

  <!-- Validation Message -->
  <div class="validation-message" *ngIf="shouldShowValidationMessage()">
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      {{ getValidationMessage() }}
    </div>
  </div>
  <!-- Add to Cart Button -->
  <div class="cart-actions">
    <button 
      type="button"
      class="btn add-to-cart-btn"
      [class.btn-primary]="canAddToCart()"
      [class.btn-secondary]="!canAddToCart()"
      [class.btn-loading]="isProcessing"
      [disabled]="isProcessing"
      (click)="addToCart()">
      
      <!-- Loading Spinner -->
      <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status">
        <span class="sr-only">Loading...</span>
      </span>
      
      <!-- Button Icon -->
      <i *ngIf="!isProcessing && canAddToCart()" class="fa fa-shopping-cart me-2" aria-hidden="true"></i>
      <i *ngIf="!isProcessing && !canAddToCart()" class="fa fa-exclamation-circle me-2" aria-hidden="true"></i>
      
      <!-- Button Text -->
      <span class="btn-text">{{ getButtonText() }}</span>
    </button>
  </div>

  <!-- Helper Text -->
  <div class="helper-text" *ngIf="canAddToCart() && !isProcessing">
    <small class="text-success">
      <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
      {{ isSearchBySize ? 'Custom wheel configuration ready' : 'Wheels verified for your vehicle' }}
    </small>
  </div>
  
  <!-- Progress Indicator for Customization -->
  <div class="customization-progress" *ngIf="isProductCustomization && custom_binders.length > 0">
    <small class="text-muted d-block mt-2">
      <strong>Customization Progress:</strong>
    </small>
    <div class="progress-items mt-1">
      <div *ngFor="let binder of custom_binders; let i = index" class="progress-item">
        <span class="wheel-label">{{ custom_binders.length > 1 ? (i === 0 ? 'Front' : 'Rear') : 'Wheel' }}:</span>
        <span class="progress-status" 
              [class.text-success]="isBinderComplete(binder)"
              [class.text-warning]="!isBinderComplete(binder)">
          <i [class.fa-check-circle]="isBinderComplete(binder)" 
             [class.fa-clock-o]="!isBinderComplete(binder)" 
             class="fa me-1" aria-hidden="true"></i>
          {{ isBinderComplete(binder) ? 'Complete' : 'Pending' }}
        </span>
      </div>
    </div>
  </div>

</div>
